import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVoiceRecord: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceRecord"><Path d="M2.5 8.5V11.5M5.5 3.5V16.5M8.5 6.5V13.5M11.5 4.5V9.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="16.5" cy="15.5" r="5" stroke="currentColor"/><Circle cx="16.5" cy="15.5" r="3.5" fill="currentColor"/></CentralIconBase>;
});

export default IconVoiceRecord;
